import { Component, OnInit, OnDestroy } from '@angular/core';

import { Alert, AlertType } from '../../../models/shared/alert.model';
import { AlertService } from '../../services/alert.service';

import { alertTransition } from '../../../shared/animations/alert.animations';
import { Subject, timer } from 'rxjs';
import { map, takeWhile, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'swb-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss'],
  animations: [alertTransition]
})
export class AlertComponent implements OnInit, OnDestroy {
  private _unsubscribe: Subject<void> = new Subject<void>();
  private _timeout = 5000; // [ms]
  private _frequency = 10; // [ms]
  public alerts: Alert[] = [];

  constructor(private alertService: AlertService) { }

  ngOnInit() {
    this.alertService.getAlert().subscribe((alert: Alert) => {
      if (!alert) {
        // clear alerts when an empty alert is received
        this.alerts = [];
        return;
      }

      // countdown in miliseconds specified
      timer(200, this._frequency).pipe(
        map(value => this._timeout / this._frequency - value),
        takeWhile(value => value > 0),
        takeUntil(this._unsubscribe)
      ).subscribe(t => {
        // set progress accordingly in percent
        alert.progress = (this._frequency / this._timeout) * t * 100;
        if (t === 1) {
          this.removeAlert(alert);
        }
      });

      // add alert to array
      this.alerts.push(alert);
    });
  }

  removeAlert(alert: Alert) {
    this.alerts = this.alerts.filter(x => x !== alert);
  }

  cssClass(alert: Alert) {
    if (!alert) {
      return;
    }

    // return css class based on alert type
    switch (alert.type) {
      case AlertType.Success:
        return 'alerts__alert--success';
      case AlertType.Error:
        return 'alerts__alert--error';
      case AlertType.Info:
        return 'alerts__alert--info';
      case AlertType.Warning:
        return 'alerts__alert--warning';
    }
  }

  ngOnDestroy(): void {
    this._unsubscribe.next();
  }
}
